"use client";

import { useEffect, useRef } from 'react';
import Lenis from 'lenis';

export const useLenis = (options: {
  duration?: number;
  easing?: (t: number) => number;
  direction?: 'vertical' | 'horizontal' | 'both';
  gestureDirection?: 'vertical' | 'horizontal' | 'both';
  smooth?: boolean;
  mouseMultiplier?: number;
  smoothTouch?: boolean;
  touchMultiplier?: number;
  infinite?: boolean;
  autoResize?: boolean;
  lerp?: number;
  normalizeWheel?: boolean;
  syncTouch?: boolean;
  onScroll?: (data: { scroll: number; velocity: number; progress: number }) => void;
} = {}) => {
  const lenisRef = useRef<Lenis | null>(null);

  useEffect(() => {
    // 清理任何可能残留的滚动状态
    window.scrollTo(0, 0);
    
    // 稍微延迟初始化，确保页面完全加载
    const timeoutId = setTimeout(() => {
      const lenis = new Lenis({
        duration: 1.2,
        easing: (t: number) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        direction: 'vertical',
        gestureDirection: 'vertical',
        smooth: true,
        mouseMultiplier: 1,
        smoothTouch: false,
        touchMultiplier: 2,
        infinite: false,
        autoResize: true,
        normalizeWheel: true,
        syncTouch: false,
        ...options,
      });

      lenisRef.current = lenis;

      // Add scroll callback if provided
      if (options.onScroll) {
        lenis.on('scroll', options.onScroll);
      }

      function raf(time: number) {
        lenis.raf(time);
        requestAnimationFrame(raf);
      }

      requestAnimationFrame(raf);
    }, 50); // 50ms 延迟

    return () => {
      clearTimeout(timeoutId);
      if (lenisRef.current) {
        if (options.onScroll) {
          lenisRef.current.off('scroll', options.onScroll);
        }
        lenisRef.current.destroy();
        lenisRef.current = null;
      }
    };
  }, []);

  return lenisRef.current;
};